import SingleTeam from './SingleTeam';

export default SingleTeam;
